import { useState } from 'react';

import useDispatch from 'shared/hooks/useDispatch';

import { CaseLevel1Code, CaseLevel2Code } from 'shared/constants/common-cases';

import { setCaseLevels } from 'pages/incident/slice';
import { UserCommonCaseCreateForm } from 'pages/incident';

import Button from '@mui/material/Button';

const CaseCreator = () => {
  const dispatch = useDispatch();

  const [isOpenIncidentForm, setIsOpenIncidentForm] = useState(false);

  const handleOpenForm = () => {
    dispatch(
      setCaseLevels({
        caseLevel1: CaseLevel1Code.Inquiry,
        caseLevel2: CaseLevel2Code.Balance,
      })
    );
    setIsOpenIncidentForm(true);
  };
  const handleCloseIncidentForm = () => {
    setIsOpenIncidentForm(false);
  };

  return (
    <>
      <Button color="secondary" onClick={handleOpenForm}>
        Uusi yhteydenotto
      </Button>
      {isOpenIncidentForm && (
        <UserCommonCaseCreateForm onClose={handleCloseIncidentForm} />
      )}
    </>
  );
};

export default CaseCreator;
